import React, { forwardRef } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import type { Props } from './types.tsx';

export const CascadingSelectOptionTruncated = forwardRef<HTMLElement, Props>(({ value }, ref) => {
	return (
		<Box as="span" xcss={cascadingValueStylesTruncated} ref={ref}>
			{value}
		</Box>
	);
});

const cascadingValueStylesTruncated = xcss({
	textOverflow: 'ellipsis',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	display: 'inline-block',
	width: '100%',
});
